// import skuProfitLogo from '../../../assets/images/SkuProfit-(RGB).png';
import { Link } from 'react-router-dom';
import silverOnyxLogo from '../../../assets/images/silveronyx-logo.png';
import silverOnyxText from '../../../assets/images/silveronyx-logo-text.png';
import './Header.css';

const Header = ({ newsLetterRef, heroRef, headQuartersRef }) => {
    function handleScroll(node) {
        node.current.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }

    return (
        <header id="header-landing">
            <div className='main-logo-container'>
                <img src={silverOnyxLogo} id='main-logo' alt='sku-profit-logo' />
                <img src={silverOnyxText} id='main-logo-text' alt='sku-profit-logo' />
            </div>
            <nav>
                <li onClick={() => handleScroll(heroRef)}>HOME</li>
                <li onClick={() => handleScroll(headQuartersRef)}>HQ</li>
                <li onClick={() => handleScroll(newsLetterRef)}>SIGNUP</li>
                <Link to='/portal'>
                    <li>
                        LOGIN
                    </li>
                </Link>
            </nav>
        </header >
    )
}

export default Header;